<template>
  <div>
    <VueCookieAcceptDecline
        :forceCookies="true"
        :ref="'myPanel1'"
        :elementId="'myPanel1'"
        :debug="false"
        :position="'bottom'"
        :type="'floating'"
        :disableDecline="false"
        :transitionName="'slideFromBottom'"
        @status="cookieStatus"
        @clickedAccept="cookieClickedAccept"
        @clickedDecline="cookieClickedDecline"
    >

      <!-- Optional -->
      <div slot="message">
        Utilizamos cookies para garantizar que obtenga la mejor experiencia en nuestro sitio web.
      </div>

      <!-- Optional -->
      <div slot="declineContent">
        No acepto
      </div>

      <!-- Optional -->
      <div slot="acceptContent">
        Acepto
      </div>
    </VueCookieAcceptDecline>
    <login v-on:goRegister="$emit('goRegister')" v-on:verifyEvent="verifyEvent"></login>
    <VerifyEvent v-on:goPlayer="goPlayer" v-if="isVerifyEvent"></VerifyEvent>

  </div>
</template>

<script>
import Login from "../components/Login";
import VerifyEvent from "../components/VerifyEvent";
import {mapState} from "vuex";
import VueCookieAcceptDecline from 'vue-cookie-accept-decline'

export default {
  name: "Login",
  data() {
    return {
      isVerifyEvent: false,
      status: null

    }
  },
  components: {
    'login': Login,
    VerifyEvent,
    VueCookieAcceptDecline
  },
  computed: {
    ...mapState(['role'])
  },
  methods: {

    async verifyEvent() {
      this.$store.commit('updateIsLoading', false)
      this.$route.path.includes('/prensa') ? this.isVerifyEvent = true : this.$emit('verifyEvent')
    },
    goPlayer(code) {
      this.$store.commit('updateIsLoading', true)
      this.isVerifyEvent = false
      console.log(localStorage.getItem('posterStartEs'))
      switch (this.role) {
        case "secretary":
        case "moderator":
        case ("journalist"):
          this.$router.push({path: `/player/${code.toLowerCase().replace(/\s/g, "")}`})
          break;
        case "user":
          this.$router.push('/')
          break
        case "graph":
          this.$router.push({path: `/dashboard`})
          break

      }
    },
    cookieStatus(status) {
      console.log('status: ' + status)
      this.status = status
    },
    cookieClickedAccept() {
      this.status = 'accept'
    },
    cookieClickedDecline() {
      console.log('here in decline')
      this.status = 'decline'
      this.$store.commit('updateIsChatActivated', false)

    },
  },
  created() {
    this.$store.commit('updateIsLoading', false)
    localStorage.clear()
  }
}
</script>

<style scoped>

</style>